export const prepare = (data, prev = null) => {
    if (Array.isArray(data)) {
        data = toStringArrayMap(data);
    }
    const result = [];
    for (const i in data) {
        if (!data.hasOwnProperty(i)) {
            continue;
        }
        result.push({
            next: data[i].length === 0
                ? null : prepare(data[i], result),
            label: i,
            prev
        });
    }
    return result;
};
// reduce?
export const toStringArrayMap = (data) => {
    const result = {};
    data.forEach((key) => {
        result[key] = [];
    });
    return result;
};
export const truncate = (width) => {
    return `
    overflow: hidden;
    white-space: nowrap;
    width: ${width};
    text-overflow: ellipsis;
  `;
};
//# sourceMappingURL=utils.js.map